var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-card__local-body",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"d-flex justify-center",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%"}}),_c('div',{staticClass:"three-wrapper"},[_c('div',{attrs:{"id":"three"}})])])
}]

export { render, staticRenderFns }